export function fully() {
  const home = $(".home-page");
  const skipToContent = $(".skip-to-content");

  skipToContent.on("keypress", function(event) {
    if(event.keyCode === 13) {
      event.preventDefault();
      skipToContent.trigger("click");
    }
  });
  this.$window.on("load", () => {
    if (!this.isDev && home) {
      const fullySections = $(".section");
      const dots = $(".fully-dots");
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      let scrollSpeed = (isMac) ? 30 : 0;
      let map = $(".map-wrap img");
      let source = map.attr("src");
      map.attr("src", "");
      let forward;
      fullySections.eq(0).addClass("active-section");
      for (let i = 1; i <= fullySections.length; i++) {
        dots.append(`<button class="fully-dot" data-num="${i}">Go to section-${i}</button>`);
      }
      fullySections.each(function () {
        $(this).attr("data-section-num", $(this).index() + 1);
      });
      let curSection = parseInt($(".active-section").attr("data-section-num"));

      if(navigator.userAgent.toLowerCase().indexOf("firefox") > -1){
        geckoWheel();
      } else {
        webkitWheel();
      }

      function webkitWheel() {
        window.addEventListener("touchstart", e => e.preventDefault(), { passive: false });

        document.addEventListener("mousewheel", (event, deltaY) => {
          event.preventDefault();
          curSection = parseInt($(".active-section").attr("data-section-num"));
          forward = event.deltaY > 0;
          if (forward) {
            if (event.deltaY > (scrollSpeed)) {
              if (curSection < fullySections.length) {
                curSection += 1;
                changeSection(curSection);
              }
            }
          } else {
            if (event.deltaY < (-scrollSpeed)) {
              if (curSection > 1) {
                curSection -= 1;
                changeSection(curSection);
              }
            }
          }
        }, { passive: false });
      }

      function geckoWheel() {
        $(window).on("mousewheel", (event, deltaY) => {
          event.preventDefault();
          curSection = parseInt($(".active-section").attr("data-section-num"));
          forward = event.deltaY < 0;
          if (forward) {
            if (event.deltaY < (-scrollSpeed)) {
              if (curSection < fullySections.length) {
                curSection += 1;
                changeSection(curSection);
              }
            }
          } else {
            if (event.deltaY > scrollSpeed) {
              if (curSection > 1) {
                curSection -= 1;
                changeSection(curSection);
              }
            }
          }
        });
      }

      function changeSection(section) {
        setTimeout(() => {
          $(`.section[data-section-num="${section}"]`).stop().addClass("active-section").siblings().removeClass("active-section");
          setActiveDot(section);
          changeDotsColor($(`.section[data-section-num="${section}"]`).hasClass("pale-section"));

          if (section == fullySections.length) {
            dots.addClass("hidden");
          } else {
            dots.removeClass("hidden");
          }
          
          if (section != 1) {
            skipToContent.addClass("hidden");
          } else {
            skipToContent.removeClass("hidden");
          }

          if(section == 2) {
            map.attr("src", source);
          }
        }, 500);
      }

      function setActiveDot(num) {
        $(`.fully-dot[data-num="${num}"]`).stop().addClass("active-dot").siblings().removeClass("active-dot");
      }

      function changeDotsColor(isPale) {
        if (isPale) {
          dots.addClass("colorize");
        } else {
          dots.removeClass("colorize");
        }
      }

      setActiveDot(curSection);
      this.$document.on("click", ".fully-dot", function () {
        let curDot = $(this).attr("data-num");
        changeSection(curDot);
      });
      this.$document.on("click", ".skip-to-content", function () {
        changeSection($(this).attr("data-go-to"));
      });
      $(".footer-section").on("click", ".to-top-btn", function () {
        if (!this.isDev) {
          changeSection($(this).attr("data-go-to"));
        }
      });
      this.$document.on("keyup", function (event) {
        let keyCode = event.which;
        if (keyCode === 40) {
          if (curSection < fullySections.length) {
            curSection += 1;
            changeSection(curSection);
          }
        } else if (keyCode === 38) {
          if (curSection > 1) {
            curSection -= 1;
            changeSection(curSection);
          }
        }
      });
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/fully.js